import { useContext } from 'react';
import { SaaSFeatureContext } from '../contexts/SaaSFeatureContext';
export function useFeatureGate() {
    const context = useContext(SaaSFeatureContext);
    if (!context) {
        throw new Error('useFeatureGate must be used within SaaSFeatureProvider');
    }
    const checkFeature = (feature) => {
        return context.flags[feature];
    };
    return {
        ...context,
        checkFeature,
        invalidateCache: context.invalidateCache,
        isSaaSConfigAvailable: context.isSaaSConfigAvailable,
        userPat: context.userPat,
        setUserPat: context.setUserPat,
        effectivePat: context.effectivePat,
        effectiveLicense: context.effectiveLicense,
        serverRejectReason: context.serverRejectReason ?? null,
    };
}
